$(function(){
    if ( $(window).width() >= 992 )
    {
        $('.mouseparallax').on('mousemove', function(e) {
            $('[data-mouseparallax-depth]').each(function(){
                let depth = $(this).data('mouseparallax-depth');
                let amountMovedX = (e.pageX * -depth/4);
                let amountMovedY = (e.pageY * -depth/4);
    
                $(this).css({
                    'transform':'translate3d(' + amountMovedX +'px,' + amountMovedY +'px, 0)',
                });
            });
        });
    }
});